import moment from 'moment';
import 'moment/locale/pt-br';
import React from 'react';
import ReactDOM from 'react-dom';
import Geolocation from 'react-geolocation';
import 'react-toastify/dist/ReactToastify.css';
import { RecoilRoot } from 'recoil';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import App from './App';
import Theme from './themes/index';
moment.locale('pt-br');

// import { makeServer } from './mock/server';
// makeServer();

ReactDOM.render(
    <Geolocation
        render={({ getCurrentPosition, fetchingPosition, position }) => (
            <Theme>
                <RecoilRoot>
                    <App position={position} />
                </RecoilRoot>
            </Theme>
        )}
    />,
    document.getElementById('root')
);
